import React from 'react';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { createCar } from '../../services/carService';

class AddCar extends React.Component {
    state = {
        data: {
            name: "",
            imgURL: "",
            duration: 0
        }
    }

    componentDidMount = async () => {

    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const data = { ...this.state.data };
        data[name] = value;
        this.setState({
            data
        });
    }

    handleSave = async () => {
        const result = await createCar(this.state.data);
        console.log(result);
        window.location = "/admin";
    }

    render() {
        const { data } = this.state;
        return <div>
            <nav class="relative bg-gray-900 py-8 px-4 flex items-center justify-between h-10 shadow-md" aria-label="Global">
                <div class="ml-4 pr-4 space-x-8">
                    <a href="/admin" class="font-medium text-gray-100 hover:text-gray-200 text-xl nav-font">Edit Car</a>
                </div>
            </nav>
            {data &&
                <div className="px-4 flex-col lg:flex-row flex lg:px-44  py-4">
                    <div className="w-full lg:w-1/2 px-0 lg:px-4">
                        <Input onChange={this.handleChange} value={data.name} name="name" label="Name" placeholder="Name" />
                        <Input onChange={this.handleChange} value={data.duration} name="duration" label="Duration" placeholder="Duration" />
                        <Input onChange={this.handleChange} value={data.imgURL} name="imgURL" label="Image URL" placeholder="Enter image URL" />
                        <div className="mt-4 flex space-x-2">
                            <Button title="Save" onClick={this.handleSave} className="w-full lg:w-1/2  " />
                        </div>
                    </div>
                </div>
            }
        </div>;
    }
}

export default AddCar;